<template>
  <div class="container">
    <div class="next">
      <div class="img">
        <img :src="logo" alt="">
      </div>
      <div class="container-ul">
        <div class="container-li1">
          <ul class=" container-li" >
            <li><a href="#">微信</a></li>
            <li><a href="#">邮箱</a></li>
            <li><a href="#">手机版</a></li>
            <li>
              <el-input style="width: 300px" size="small" v-model="searchWords" placeholder="请输入关键词" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="onSearchClick"></el-button>
              </el-input>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import logo from '@/assets/logo.png'
export default {
  name: "Headr",
  data(){
    return{
      logo:logo,
      searchWords:'',
    }
  },
  methods:{
    onSearchClick(){
      this.$emit('search-click', this.searchWords)
    }
  }
}
</script>
<style scoped>
.img{background-color: white;}
.img img{display: inline-block;float: left;width: 500px;margin-top: 15px;height: 60px}
.container{background-color: white;width: 100%;}
.next{width: 80%;height: 80px;margin: 0 auto;display: flex;justify-content: center}
.container-ul{background-color: white;float: right;}
.container-li{width: 400px;font-size: 14px;}
.container-li1 li{float: right;margin: 0 10px 10px 0;}
a{text-decoration: none;color: #000;}
a:hover{color: red;}
li{list-style-type: none;display:inline;}
</style>



// WEBPACK FOOTER //
// src/components/Headr.vue